import { useContext, useState } from 'react';

import { Layout, Row, Col, Alert, Button } from 'antd-v4';

import Sidebar from './components/menu/Sidebar';
import MenuHeader from './components/header';
import ScrollTop from './components/scroll-to-top';
import { useCustomise } from '../context/customiseContext';
import { useNavigate } from 'react-router-dom';
import { FirebaseContext } from '../context/firebaseContext';
import { isCurrentDateInRange } from '@leedpulse-monorepo/utils';
import { AIStatus } from '@leedpulse-monorepo/enums';
import { EnvironmentBanner, getEnvironmentBannerMode } from '@leedpulse-monorepo/components';
import { metadata } from '@leedpulse-monorepo/firebase-metadata';

export default function VerticalLayout(props) {
  const { children } = props;
  const { userData } = useContext(FirebaseContext);
  // Purement derive. C'etait du state ecrit par une garde au rendu, qui ne
  // tirait qu'au tout premier montage : le Router rend un <Route> parent DISTINCT
  // par chemin, donc ce layout est demonte/remonte a chaque navigation, et
  // remontait avec `days_off` deja present — bandeau muet en conges.
  const daysOffRanges = userData?.days_off
    ? (Array.isArray(userData.days_off[0]) ? userData.days_off : [userData.days_off])
    : null;
  const isOnDaysOff = daysOffRanges ? isCurrentDateInRange(daysOffRanges) : false;

  const [visible, setVisible] = useState(false);
  const [ai, ] = useState(
    JSON.parse(localStorage.getItem('leedpulse-ai'))
  );

  // Context
  const { contentWidth } = useCustomise();
  const navigate = useNavigate();


  return (
    <Layout className="hp-app-layout">
      <EnvironmentBanner mode={getEnvironmentBannerMode(metadata('frontend'))} />
      <Sidebar visible={visible} setVisible={setVisible} />

      <Layout className="hp-bg-black-20 hp-bg-color-dark-90">
        {ai != null && ai.status != null && ai.status !== AIStatus.active && (
          <Alert
            closable
            message={
              ai.status === AIStatus.pausedFull
                ? "L'IA de votre compte est en pause. Aucun message ne sera envoyé."
                : "L'IA de votre compte est en pause pour les nouveaux contacts. Aucun message ne sera envoyé."
            }
            icon={
              <span role="img" aria-label="pause button">
                ⏸️
              </span>
            }
            type={'error'}
            showIcon
            banner
            action={
              <Button
                size={'small'}
                type={'primary'}
                onClick={() => navigate('/profile/customization')}
              >
                Changer le statut de l'IA
              </Button>
            }
          />
        )}
        {isOnDaysOff && (
          <Alert
            closable
            message={
              'Vous êtes actuellement absent. Aucun message ne sera envoyé.'
            }
            type={'warning'}
            icon={
              <span role="img" aria-label="beach with umbrella">
                🏝️
              </span>
            }
            showIcon
            banner
            action={
              <Button
                size={'small'}
                type={'primary'}
                onClick={() => navigate('/profile/absences')}
              >
                Changer mon statut
              </Button>
            }
          />
        )}

        <MenuHeader setVisible={setVisible} />
        <Layout.Content className="">
          <Row justify="center">
            {contentWidth === 'full' && (
              <Col style={{ width: '100%' }}>{children}</Col>
            )}

            {contentWidth === 'boxed' && (
              <Col className="hp-w-100" style={{ maxWidth: 936 }}>
                {children}
              </Col>
            )}
          </Row>
        </Layout.Content>

        {/* <MenuFooter /> */}
      </Layout>

      <ScrollTop />
    </Layout>
  );
}
